var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLymph = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 3)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.308,
  cy: 4.461,
  rx: 1.549,
  ry: 2.112,
  transform: "rotate(-13 4.308 4.461)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.916 0c-.832.381-1.498 1.048-2 2M.532.743c.734.348 1.416 1.06 2.047 2.138"
})), /*#__PURE__*/React.createElement("path", {
  d: "M7.832 9.099 9 10.5"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.308,
  cy: 17.461,
  rx: 1.549,
  ry: 2.112,
  transform: "rotate(-13 16.308 17.461)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.916 13 15 15.5m-5.355-2.563.125 2.54"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.54,
  cy: 11.449,
  rx: 2.5,
  ry: 1.5,
  transform: "rotate(-11 11.54 11.45)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 19.54,
  cy: 10.449,
  rx: 2.5,
  ry: 1.5,
  transform: "rotate(-11 19.54 10.45)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.827 10.963c-.846-.349-1.788-.381-2.827-.099"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.082,
  cy: 17.99,
  rx: 2.5,
  ry: 1.5,
  transform: "rotate(86 10.082 17.99)"
}))));
export { SvgLymph as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0ibm9uemVybyIgc3Ryb2tlPSIjMzMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij4KICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDMpIj4KICAgICAgICAgICAgPGVsbGlwc2UgY3g9IjQuMzA4IiBjeT0iNC40NjEiIHJ4PSIxLjU0OSIgcnk9IjIuMTEyIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTMgNC4zMDggNC40NjEpIi8+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik01LjkxNiAwYy0uODMyLjM4MS0xLjQ5OCAxLjA0OC0yIDJNLjUzMi43NDNjLjczNC4zNDggMS40MTYgMS4wNiAyLjA0NyAyLjEzOCIvPgogICAgICAgIDwvZz4KICAgICAgICA8cGF0aCBkPSJNNy44MzIgOS4wOTlMOSAxMC41Ii8+CiAgICAgICAgPGVsbGlwc2UgY3g9IjE2LjMwOCIgY3k9IjE3LjQ2MSIgcng9IjEuNTQ5IiByeT0iMi4xMTIiIHRyYW5zZm9ybT0icm90YXRlKC0xMyAxNi4zMDggMTcuNDYxKSIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMi45MTYgMTNMMTUgMTUuNU05LjY0NSAxMi45MzdsLjEyNSAyLjU0Ii8+CiAgICAgICAgPGVsbGlwc2UgY3g9IjExLjU0IiBjeT0iMTEuNDQ5IiByeD0iMi41IiByeT0iMS41IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTEgMTEuNTQgMTEuNDUpIi8+CiAgICAgICAgPGVsbGlwc2UgY3g9IjE5LjU0IiBjeT0iMTAuNDQ5IiByeD0iMi41IiByeT0iMS41IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTEgMTkuNTQgMTAuNDUpIi8+CiAgICAgICAgPHBhdGggZD0iTTE2LjgyNyAxMC45NjNjLS44NDYtLjM0OS0xLjc4OC0uMzgxLTIuODI3LS4wOTkiLz4KICAgICAgICA8ZWxsaXBzZSBjeD0iMTAuMDgyIiBjeT0iMTcuOTkiIHJ4PSIyLjUiIHJ5PSIxLjUiIHRyYW5zZm9ybT0icm90YXRlKDg2IDEwLjA4MiAxNy45OSkiLz4KICAgIDwvZz4KPC9zdmc+Cg==";